import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

export type SentryOptions = {
  app: App
  router: Router
}

export const useSentry = (options: SentryOptions) => {
  Sentry.init({
    app: options.app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({
        router: options.router,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    tracePropagationTargets: ['localhost', /^\/api/],
    replaysSessionSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    ),
    replaysOnErrorSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
    ),
    environment: import.meta.env.NODE_ENV,
    release: import.meta.env.VITE_SENTRY_RELEASE,
  })
}
